import React from 'react'

export default function ThumbsDownIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.48532 13.0746C5.23621 14.2371 6.1224 15.3333 7.3113 15.3333C7.74057 15.3333 8.1395 15.1122 8.36704 14.7482L11.3346 10H13.3346C14.071 10 14.668 9.40307 14.668 8.66667V3.33333C14.668 2.59695 14.071 2 13.3346 2H3.90404C3.1465 2 2.45397 2.42801 2.11518 3.10557L0.949495 5.43695C0.764355 5.80723 0.667969 6.21553 0.667969 6.62951V8.66667C0.667969 9.77127 1.5634 10.6667 2.66797 10.6667H6.0013L5.48532 13.0746ZM11.3346 3.33333V8.66667H13.3346V3.33333H11.3346ZM7.26364 13.9979L10.0013 9.6176V3.33333H3.90404C3.65152 3.33333 3.42068 3.476 3.30776 3.70186L2.14207 6.03323C2.0495 6.21837 2.0013 6.42252 2.0013 6.62951V8.66667C2.0013 9.03487 2.29978 9.33333 2.66797 9.33333H6.0013C6.40396 9.33333 6.78504 9.51527 7.03817 9.8284C7.2913 10.1415 7.38944 10.5523 7.30504 10.9461L6.78904 13.354C6.72117 13.6707 6.94797 13.9703 7.26364 13.9979Z"
        fill="currentColor"
      />
    </svg>
  )
}
